export default "__VITE_ASSET__vrvFGdDD__"